import { UserProfileOemMapping } from 'common/types/Entities';

import { _request, APIBaseResponse, APIMethod } from '..';
import { buildQueryParams } from '../apiHelpers';

const USER_PROFILES_PREFIX = '/userprofiles';

type APIUserProfilesGetResponse = APIBaseResponse<UserProfileOemMapping[]>;

export type APIUserProfilesGetByEmailParams = {
    email: string;
};

export const APIUserProfilesByEmailGetList: APIMethod<APIUserProfilesGetByEmailParams, APIUserProfilesGetResponse> = params => {
    const queryParams = buildQueryParams(params);
    const requestPath = `${USER_PROFILES_PREFIX}` + (queryParams && `?${queryParams}`);
    return _request('GET', requestPath);
};

type APIUserProfilesGetByIdParams = {
    userId: string;
};

export const APIUserProfilesByIdGetList: APIMethod<APIUserProfilesGetByIdParams, APIUserProfilesGetResponse> = params => {
    return _request('GET', `${USER_PROFILES_PREFIX}/${params.userId}`);
};
